import makeStyles from '@mui/styles/makeStyles';

import { signupTokens, teal900 } from '@/theme/colors';

// Shared signup-modal chrome styles used by both the partner-driven
// NewCustomerSignupModal and the self-service SelfServiceSMBSignupModal.
//
// Lives in `shared/` so a partner-only style change doesn't silently
// mutate self-service visuals (and vice versa). The partner modal's
// own styles.ts is a superset that still carries phone/scheduling-
// specific classes; this file is the minimum surface both modals agree
// on.
export const useSignupModalStyles = makeStyles({
  paper: {
    margin: 'auto',
    padding: '0 !important',
  },
  formContent: {
    padding: '16px 24px',
    backgroundColor: 'var(--surfaceCard)',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderTop: '1px solid var(--surfaceBorder)',
    backgroundColor: 'var(--surfaceElevated)',
  },
  backButton: {
    // Same #005755 as teal900 in light mode, but teal900 stays dark in dark mode and
    // can't be read on the dark footer.
    color: 'var(--brandPrimary)',
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  continueButton: {
    backgroundColor: teal900,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    padding: '8px 24px !important',
    minHeight: '32px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: signupTokens.primaryHoverDark,
    },
    '&:disabled': {
      backgroundColor: signupTokens.borderMid,
      color: signupTokens.textDisabled,
    },
  },
});
